const STORAGE_KEY = 'chat_rate_limit';

const defaultLimits = {
  hourly: { max: 5, windowMs: 60 * 60 * 1000 },
  daily:  { max: 20, windowMs: 24 * 60 * 60 * 1000 },
};

const localStorageAdapter = {
  get: async (key) => {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },
  set: async (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
  },
};

function formatTimeRemaining(ms) {
  const totalMinutes = Math.ceil(ms / 60000);
  if (totalMinutes < 60) {
    return `${totalMinutes} minuto${totalMinutes !== 1 ? 's' : ''}`;
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (minutes === 0) {
    return `${hours} hora${hours !== 1 ? 's' : ''}`;
  }
  return `${hours}h ${minutes}min`;
}

export const createRateLimiter = (options = {}) => {
  const {
    storage = localStorageAdapter,
    limits = defaultLimits,
  } = options;

  const check = async () => {
    const data = (await storage.get(STORAGE_KEY)) || {};
    const now = Date.now();

    if (data.hourly && (now - data.hourly.windowStart) < limits.hourly.windowMs) {
      if (data.hourly.count >= limits.hourly.max) {
        const timeMs = data.hourly.windowStart + limits.hourly.windowMs - now;
        return {
          allowed: false,
          reason: `Limite de ${limits.hourly.max} perguntas por hora atingido. Volte em aproximadamente ${formatTimeRemaining(timeMs)}.`,
        };
      }
    }

    if (data.daily && (now - data.daily.windowStart) < limits.daily.windowMs) {
      if (data.daily.count >= limits.daily.max) {
        const timeMs = data.daily.windowStart + limits.daily.windowMs - now;
        return {
          allowed: false,
          reason: `Limite de ${limits.daily.max} perguntas por dia atingido. Volte em aproximadamente ${formatTimeRemaining(timeMs)}.`,
        };
      }
    }

    return { allowed: true };
  };

  const checkAndIncrement = async () => {
    const data = (await storage.get(STORAGE_KEY)) || {};
    const now = Date.now();

    let hourly = data.hourly;
    if (!hourly || (now - hourly.windowStart) >= limits.hourly.windowMs) {
      hourly = { count: 0, windowStart: now };
    }
    if (hourly.count >= limits.hourly.max) {
      const timeMs = hourly.windowStart + limits.hourly.windowMs - now;
      return {
        allowed: false,
        reason: `Limite de ${limits.hourly.max} perguntas por hora atingido. Volte em aproximadamente ${formatTimeRemaining(timeMs)}.`,
      };
    }

    let daily = data.daily;
    if (!daily || (now - daily.windowStart) >= limits.daily.windowMs) {
      daily = { count: 0, windowStart: now };
    }
    if (daily.count >= limits.daily.max) {
      const timeMs = daily.windowStart + limits.daily.windowMs - now;
      return {
        allowed: false,
        reason: `Limite de ${limits.daily.max} perguntas por dia atingido. Volte em aproximadamente ${formatTimeRemaining(timeMs)}.`,
      };
    }

    hourly.count++;
    daily.count++;
    await storage.set(STORAGE_KEY, { hourly, daily });

    return { allowed: true };
  };

  return { check, checkAndIncrement };
};

const rateLimiter = createRateLimiter();
export default rateLimiter;
